<template>
  <el-dialog custom-class="connection-setting-container dialog-size-middle"
             title="接続先一覧"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="connection-setting-main-container">
      <fixed-header-table :fixed="connections != null" style="height: 480px;">
        <tr slot="header">
          <th>接続先</th>
          <th style="flex-grow: 0; min-width: 120px; max-width: 120px;">タイプ</th>
          <th style="flex-grow: 0; min-width: 180px; max-width: 180px;">作成日時</th>
          <th style="flex-grow: 0; min-width: 100px; max-width: 100px;"></th>
          <th style="flex-grow: 0; min-width: 100px; max-width: 100px;"></th>
        </tr>
        <tr v-for="connection in connections">
          <td><span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{connection.connectionName}}</span>
          </td>
          <td style="flex-grow: 0; min-width: 120px; max-width: 120px;">{{CONNECTION_TYPES[connection.type]}}</td>
          <td style="flex-grow: 0;">{{connection.createdAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD HH:mm')}}</td>
          <td style="flex-grow: 0; justify-content: center; min-width: 100px; max-width: 100px;">
            <el-button type="primary" @click="onClickEditConnection(connection)">
              <font-awesome-icon class="icon setting" icon="cog"/>
            </el-button>
          </td>
          <td style="flex-grow: 0; justify-content: center; min-width: 100px; max-width: 100px;">
            <el-button type="danger" @click="onClickDeleteConnection(connection)">
              <font-awesome-icon class="icon delete" icon="trash-alt"/>
            </el-button>
          </td>
        </tr>
      </fixed-header-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onClickAddConnection">追加</el-button>
    </span>
    <connection-setting v-if="visibleConnectionSetting"
                        @close="onCloseConnectionSetting"
                        :selectedConnectionId="editingConnectionId">
    </connection-setting>

  </el-dialog>
</template>

<script lang="js">
import WebApiClient from '../../../api/web'
import { Code } from '../../../api/base'
import MessageBox from '../../../utils/message-box'
import ConnectionSettingDialogCmp from './connection-setting.vue'

export default {
  name: 'ConnectionListDialogCmp',
  components: {
    'connection-setting': ConnectionSettingDialogCmp

  },
  props: {},
  computed: {
    CONNECTION_TYPES () {
      return {
        postgresql: 'PostgreSQL',
        mysql: 'MySQL',
        redshift: 'Redshift',
        ftp: 'FTP',
        sftp: 'SFTP'
      }
    }
  },
  data () {
    return {
      connections: [],
      editingConnectionId: '',
      visible: true,
      visibleConnectionSetting: false
    }
  },
  mounted () {
    this.refreshConnections()
  },
  methods: {
    onClickAddConnection () {
      this.editingConnectionId = null
      this.visibleConnectionSetting = true
    },
    onClickEditConnection (connection) {
      this.editingConnectionId = connection.connectionId
      this.visibleConnectionSetting = true
    },
    onClickDeleteConnection (connection) {
      MessageBox.confirm(this,
        `${connection.connectionName}の接続先を削除しますか？<br>削除すると、この接続先を使用している学習データの更新はできなくなりますがよろしいですか？`, {
          dangerouslyUseHTMLString: true
        }).then(() => {
        WebApiClient.deleteConnection(this, connection.connectionId).then((response) => {
          if (response.data.code === Code.SUCCESS) {
            this.connections.splice(this.connections.indexOf(connection), 1)
            this.$forceUpdate()
          }
        }).catch(() => {})
      })
    },
    onCloseConnectionSetting () {
      this.visibleConnectionSetting = false
      this.refreshConnections()
    },
    refreshConnections () {
      WebApiClient.getConnections(this).then(response => {
        this.connections = response.data.result.connections
        this.$forceUpdate()
      })
    }
  }
}

</script>

<style type="scss" scoped>
  .connection-setting-main-container {
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/connection/dialogs/connection-list.vue